import React from 'react';
import CardItem from 'slickpay/online/CardItem.component';

import { DEPOSIT_CARD_IMAGES, NO_SHOW_CARD_IMAGES, PROTECTION_CARD_IMAGES } from 'constants/images/slickPay.const';
import { useCountryImage } from 'hooks/useCountryImage.hook';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ThreeCards.module.scss';

const LINK_PROTECTION = 'https://help.getslick.com/en/articles/4893453-all-about-deposits';
const LINK_DEPOSIT = 'https://help.getslick.com/en/articles/8645675-how-to-request-a-deposit-from-a-client';
const LINK_NO_SHOW = 'https://help.getslick.com/en/articles/4924817-no-show-protection-for-online-bookings';

const ThreeCards = () => {
  const { t } = useTranslation();

  const protectionCardImage = useCountryImage(PROTECTION_CARD_IMAGES);
  const depositCardImage = useCountryImage(DEPOSIT_CARD_IMAGES);
  const noShowCardImage = useCountryImage(NO_SHOW_CARD_IMAGES);

  return (
    <div data-bem="ThreeCards" className={CN.space}>
      <div className={CN.header}>
        <div className={CN.title}>{t('slickPay.onlinePayments.title')}</div>
      </div>
      <div className={CN.container} data-bem="ThreeCards__container">
        <CardItem imageSrc={protectionCardImage} title={t('slickPay.onlinePayments.protectionTitle')} link={LINK_PROTECTION} />
        <div className={CN.middleCard}>
          <CardItem imageSrc={depositCardImage} title={t('slickPay.onlinePayments.depositTitle')} link={LINK_DEPOSIT} />
        </div>

        <CardItem imageSrc={noShowCardImage} title={t('slickPay.onlinePayments.noShowTitle')} link={LINK_NO_SHOW} />
      </div>
    </div>
  );
};
export default ThreeCards;
